import React from 'react';
import { Button } from './Button';
import { ArrowRight } from 'lucide-react';
import { useModal } from './ModalContext';
export const CallToAction = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section id="cta" className="w-full bg-white py-section-mobile md:py-section-desktop relative overflow-hidden" data-id="element-38">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="max-w-6xl mx-auto" data-id="element-40">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 items-center" data-id="element-41">
            <div className="lg:col-span-12" data-id="element-42"></div>
            <div className="lg:col-span-12" data-id="element-43">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KFpKL4x8ZRHY6kZ6KEr1H/image.png" alt="Decorative divider with plant illustrations" className="w-full mx-auto mb-8" data-id="element-44" />
              <div className="bg-gradient-to-br from-primary-50 to-blue-50 rounded-2xl shadow-glow p-4 md:p-8 lg:p-10 space-y-8 border border-primary-100 transition-all duration-300 hover:shadow-glow-hover backdrop-blur-sm lg:max-w-[80%] lg:mx-auto" data-id="element-45">
                <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-cyan-800 mb-4 leading-tight text-center" data-id="element-46">
                  Bring Nisa to your school or district
                </h2>
                <div className="space-y-6 md:space-y-8 max-w-[80%] mx-auto" data-id="element-47">
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed text-center" data-id="element-48">
                    Request a walkthrough to learn how Nisa can strengthen
                    coaching in your school or district.
                  </p>
                </div>
                <div className="flex justify-center" data-id="element-49">
                  <div className="transform scale-110" data-id="element-50">
                    <Button type="button" size="lg" onClick={openTalkToUs} data-id="element-51">
                      Request a Nisa demo
                      <ArrowRight className="w-5 h-5 ml-2" data-id="element-52" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};